/*
 *@description:http后台通用请求接口
 *@author: donghang
 *@date: 2019-08-22 11:19:09
 *@version: V1.0.0
*/
import request from './request'

/** POST请求 */
/** params在restful后台使用RequestParam解析，data在restful后台使用RequestBody解析消息体 */
export function postAction(url, parameter) {
  return request({
    url: url,
    method: "post",
    data: parameter
  })
}

/** GET、POST请求 */
/** params在restful后台使用RequestParam解析，data在restful后台使用RequestBody解析消息体 */
export function httpAction(url, parameter, method) {
  return request({
    url: url,
    method: method,
    data: parameter
  })
}

/** PUT请求 */
/** params在restful后台使用RequestParam解析，data在restful后台使用RequestBody解析消息体 */
export function putAction(url, parameter) {
  return request({
    url: url,
    method: "put",
    data: parameter
  })
}

/** GET请求 */
/** params在restful后台使用RequestParam解析，data在restful后台使用RequestBody解析消息体 */
export function getAction(url, parameter) {
  return request({
    url: url,
    method: "get",
    params: parameter //
  })
}

/** DELETE请求 */
/** params在restful后台使用RequestParam解析，data在restful后台使用RequestBody解析消息体 */
export function deleteAction(url, parameter) {
  return request({
    url: url,
    method: "delete",
    data: parameter
  })
}



// WEBPACK FOOTER //
// ./src/request/http.js